export const DOMAIN_TYPES = {
  FRONTEND: 'frontend',
  BACKEND: 'backend'
};

export const MULTI_LANG_CONTENT_TYPES = {
  step: 'STEP',
  content: 'CONTENT'
};

export const VALID_CHILD_CONTENT_TYPES = {
  [MULTI_LANG_CONTENT_TYPES.step]: ['customizePageSection'],
  [MULTI_LANG_CONTENT_TYPES.content]: ['customizePageCodeContent', 'customizePageTextContent']
};
